export const PLATFORMS_FETCH = 'PLATFORMS_FETCH';
export const PLATFORMS_IS_FETCING = 'PLATFORMS_IS_FETCING';
export const PLATFORMS_API = 'platforms';
export const PLATFORM_EDIT = 'PLATFORM_EDIT';
export const PLATFORM_SAVE = 'PLATFORM_SAVE';
export const PLATFORM_FILTER = 'PLATFORM_FILTER';


// WEBPACK FOOTER //
// ./src/constants/platforms.js